import {
    IconAd2,
    IconHeart,
    IconHome,
    IconLogin2,
    IconLogout,
    IconMenu2,
    IconMessage,
    IconPhoto,
    IconSearch,
    IconUser,
} from "@tabler/icons-react";
import { useContext, useState } from "react";
import { Badge, Drawer } from "antd";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import { PhoneOutlined } from "@ant-design/icons";
import { BadgesContext } from "../../context/BadgesContext";
import LoginModal from "../modals/LoginModal";
import { ModalContext } from "../../context/ModalContext";
import FavoritesDrawer from "./FavoritesDrawer";

const MobileBottomBar = () => {
    const { isAuthenticated, user, logout } = useContext(AuthContext);
    const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
    const [favoritesDrawerOpen, setFavoritesDrawerOpen] = useState(false);
    const badges = useContext(BadgesContext);
    const { showLoginModal, isLoginModalOpen, hideLoginModal } = useContext(ModalContext);

    const itemClass = "flex flex-col items-center justify-center px-5 py-3 gap-0 whitespace-nowrap text-white";

    const toggleMobileDrawer = () => {
        setMobileDrawerOpen((prev) => !prev);
    };

    const closeMobileDrawer = () => {
        setMobileDrawerOpen(false);
    };

    const toggleFavoritesDrawer = () => {
        setFavoritesDrawerOpen((prev) => !prev);
    };

    const closeFavoritesDrawer = () => {
        setFavoritesDrawerOpen(false);
    };

    return (
        <div className="bg-primary text-white fixed bottom-0 w-full flex justify-around z-50 sm:hidden">
            <ul
                className={`grid ${
                    isAuthenticated ? "grid-cols-5" : "grid-cols-4"
                } justify-between w-full items-center list-none m-0`}
            >
                <Link to="/">
                    <li className={itemClass}>
                        <IconHome />
                        Etusivu
                    </li>
                </Link>
                <Link to={"/kohteet"}>
                    <li className={itemClass}>
                        <IconSearch />
                        Haku
                    </li>
                </Link>
                {isAuthenticated ? (
                    <>
                        <Badge count={badges.favorites} size="small" color="blue" offset={[4, 0]}>
                            <li className={itemClass} onClick={toggleFavoritesDrawer}>
                                <IconHeart />
                                Suosikit
                            </li>
                        </Badge>
                        <Badge count={badges.auctions} size="small" color="blue" offset={[4, 0]}>
                            <Link to="/oma-sivu">
                                <li className={itemClass}>
                                    <IconUser />
                                    Oma tili
                                </li>
                            </Link>
                        </Badge>
                    </>
                ) : (
                    <li className={itemClass} onClick={() => showLoginModal("login")}>
                        <IconLogin2 />
                        Kirjaudu
                    </li>
                )}
                <li className={itemClass} onClick={toggleMobileDrawer}>
                    <IconMenu2 />
                    Valikko
                </li>
            </ul>
            <LoginModal isOpen={isLoginModalOpen} onClose={hideLoginModal} />
            {/* Mobile Drawer (below md) */}
            <Drawer
                title="Valikko"
                placement="right"
                closable={true}
                onClose={closeMobileDrawer}
                open={mobileDrawerOpen}
                zIndex={40}
                styles={{ header: { display: 'none' } }}
            >
                <div className="flex flex-col space-y-4 h-full">
                    <Link to="/ehdot-ja-ohjeet" onClick={closeMobileDrawer}>
                        Ehdot ja ohjeet
                    </Link>
                    <Link to="/yhteystiedot" onClick={closeMobileDrawer}>
                        Yhteystiedot
                    </Link>
                    <div className="flex md:hidden items-center space-x-2 h-10 text-black">
                        <PhoneOutlined />
                        <Link to="tel:+358503753594">+358 50 375 3594</Link>
                    </div>

                    <hr />

                    <Link to="/myydaan-lomaosake" onClick={closeMobileDrawer}>
                        Myytävät lomaosakkeet
                    </Link>
                    <Link to="/vuokrataan-lomaosake" onClick={closeMobileDrawer}>
                        Vuokrattavat lomaosakkeet
                    </Link>
                    <Link to="/huutokaupataan-lomaosake" onClick={closeMobileDrawer}>
                        Huutokaupattavat lomaosakkeet
                    </Link>
                    <Link to="/artikkelit" onClick={closeMobileDrawer}>
                        Artikkelit
                    </Link>

                    {isAuthenticated && (
                        <>
                            <hr />
                            <div className="text-base space-y-2">
                                <Link to="/oma-sivu" onClick={closeMobileDrawer} className="flex items-center gap-2">
                                    <IconUser size={16} /> Oma sivu
                                </Link>
                                <Link
                                    to="/oma-sivu/ilmoitukset"
                                    onClick={closeMobileDrawer}
                                    className="flex items-center gap-2"
                                >
                                    <IconAd2 size={16} /> Omat ilmoitukset
                                </Link>
                                <Link
                                    to="/oma-sivu/viestit"
                                    onClick={closeMobileDrawer}
                                    className="flex items-center gap-2"
                                >
                                    <IconMessage size={16} /> Viestit
                                </Link>
                                <Link
                                    to="/oma-sivu/kuvapankki"
                                    onClick={closeMobileDrawer}
                                    className="flex items-center gap-2"
                                >
                                    <IconPhoto size={16} /> Kuvapankki
                                </Link>
                            </div>

                            <div className="flex-1"></div>

                            <div
                                className="pb-20 flex items-center gap-2 text-base text-red-600 cursor-pointer"
                                onClick={() => {
                                    logout();
                                    closeMobileDrawer();
                                }}
                            >
                                <IconLogout size={16} /> Kirjaudu ulos
                            </div>
                        </>
                    )}
                </div>
            </Drawer>
            <FavoritesDrawer open={favoritesDrawerOpen} onClose={closeFavoritesDrawer} />
        </div>
    );
};

export default MobileBottomBar;
